import { Outlet } from 'react-router-dom';
import { Navbar } from '../shared/Navbar';
import { Footer } from '../shared/Footer';
import { FloatingActions } from '../shared/FloatingActions';
import '../styles/layout.css';

export function Layout() {
  return (
    <div className="appShell">
      <a className="skip-link" href="#main">
        تخطّي إلى المحتوى
      </a>
      <Navbar />
      <main id="main" className="main">
        <Outlet />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}

